export const normalizeTeamValueId = (value) => {
  if (!value) return '';
  if (typeof value === 'object') {
    return String(value.id || value._id || value.playerId || value.userId || '');
  }
  return String(value);
};

export const resolveTeamPlayer = (players = [], playerRef) => {
  const refId = normalizeTeamValueId(playerRef);
  if (!refId && !playerRef) return null;

  if (playerRef && typeof playerRef === 'object') {
    return playerRef.player || playerRef;
  }

  return (players || [])
    .map((entry) => entry?.player || entry)
    .find((player) => normalizeTeamValueId(player) === refId) || null;
};

export const normalizeAuctionTeams = (teamSetup) => {
  const teams = teamSetup?.teams || [];
  const seenNames = new Set();
  const uniqueTeams = [];

  teams.forEach((team, index) => {
    const key = (team.name || `team-${index}`).trim().toLowerCase();
    if (seenNames.has(key)) return;
    seenNames.add(key);

    uniqueTeams.push({
      ...team,
      name: team.name || `Team ${uniqueTeams.length + 1}`,
    });
  });

  return uniqueTeams;
};

export const buildTeamSlug = (teamName, fallbackIndex = 0) => {
  const baseName = (teamName || `Team ${fallbackIndex + 1}`).toString().trim().toLowerCase();
  const slug = baseName.replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  return slug || `team-${fallbackIndex + 1}`;
};

export const findTeamBySlug = (teams, slug) =>
  teams.find((team, index) => buildTeamSlug(team.name, index) === slug);
